module.exports = __webpack_public_path__ + "img/20191119163612479.7b88447d.jpg";